<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="巡检计划">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="`iwt-wf`.yw_artificial_patrol_plan,plan_name,id"
                placeholder="请选择计划"
                v-model="queryParam.patrolPlanId"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="状态">
              <j-multi-select-tag
                @change="searchQuery"
                dictCode="dev_maintaince_task_status"
                placeholder="请选择任务状态"
                type="checkbox"
                v-model="queryParam.taskStatus"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="计划执行时间">
              <j-date
                :show-time="true"
                date-format="YYYY-MM-DD HH:mm:ss"
                placeholder="请选择计划执行时间"
                v-model="queryParam.taskPlanTime"
              ></j-date>
            </a-form-item>
          </a-col>-->
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="执行人">
              <j-search-select-tag
                :async="true"
                :pageSize="100"
                @change="searchQuery"
                dict="sys_user,realname,id"
                placeholder="请输入执行人"
                tenant="rel_tenant_ids"
                v-model="queryParam.taskRealPerson"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button> -->
      <a-button @click="handleExportXls('巡检任务')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: true }"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="execute(record)" v-if="record.taskStatus != '2'">执行</a>
          <a-divider type="vertical" v-if="record.taskStatus != '2'" />
          <a @click="detail(record)">详情</a>
        </span>
      </a-table>
    </div>

    <!-- <yw-artificial-patrol-task-modal @ok="modalFormOk" ref="modalForm"></yw-artificial-patrol-task-modal> -->

    <yw-artificial-patrol-task-detail-modal @ok="modalFormOk" ref="modalForm"></yw-artificial-patrol-task-detail-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import YwArtificialPatrolTaskModal from './modules/YwArtificialPatrolTaskModal'
  import YwArtificialPatrolTaskDetailModal from './modules/YwArtificialPatrolTaskDetailModal'

  export default {
    name: 'YwArtificialPatrolTaskList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      YwArtificialPatrolTaskModal,
      YwArtificialPatrolTaskDetailModal
    },
    data () {
      return {
        description: '巡检任务管理页面',
        isorter: {
          column: 'taskPlanTime',
          order: 'desc'
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: 'center',
            customRender: function (t, r, index) {
              return parseInt(index) + 1
            }
          },
          {
            title: '任务单号',
            align: 'center',
            dataIndex: 'taskCode'
          },
          {
            title: '巡检计划',
            align: 'center',
            dataIndex: 'patrolPlanId_dictText'
          },
          {
            title: '设备数量',
            align: 'center',
            dataIndex: 'devCount'
          },
          {
            title: '任务状态',
            align: 'center',
            dataIndex: 'taskStatus_dictText'
          },
          {
            title: '计划执行时间',
            align: 'center',
            sorter: true,
            dataIndex: 'taskPlanTime'
          },
          {
            title: '实际执行时间',
            align: 'center',
            dataIndex: 'taskRealTime'
          },
          {
            title: '执行人',
            align: 'center',
            dataIndex: 'taskRealPerson_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: '/device/patrol/ywArtificialPatrolTask/list',
          delete: '/device/patrol/ywArtificialPatrolTask/delete',
          deleteBatch: '/device/patrol/ywArtificialPatrolTask/deleteBatch',
          exportXlsUrl: '/device/patrol/ywArtificialPatrolTask/exportXls',
          importExcelUrl: 'device/patrol/ywArtificialPatrolTask/importExcel'
        },
        dictOptions: {},
        superFieldList: []
      }
    },
    created () {
      this.getSuperFieldList()
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
      }
    },
    methods: {
      execute (record) {
        this.$refs.modalForm.disableSubmit = false
        this.$refs.modalForm.show(record)
      },
      detail (record) {
        this.$refs.modalForm.disableSubmit = true
        this.$refs.modalForm.show(record)
      },
      report (record) { },
      initDictConfig () { },
      getSuperFieldList () {
        let fieldList = []
        fieldList.push({ type: 'string', value: 'taskCode', text: '任务单号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'patrolPlanId', text: '巡检计划', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devCount', text: '设备数量', dictCode: '' })
        fieldList.push({ type: 'string', value: 'taskStatus', text: '任务状态', dictCode: '' })
        fieldList.push({ type: 'datetime', value: 'taskPlanTime', text: '计划执行时间' })
        fieldList.push({ type: 'datetime', value: 'taskRealTime', text: '实际执行时间' })
        fieldList.push({ type: 'string', value: 'taskRealPerson', text: '执行人', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>
